import moment from 'moment';

import { REQUEST_QUESTION_TYPES } from '../constants/common.constants';
import {
  IDateAndTimeRequestQuestionDetail,
  IRequestQuestionAnswerDetail,
  IRequestQuestionDetail,
} from '../interfaces/i-order-request.interface';

export const filterRequestDetails = (details: IRequestQuestionDetail[] = []): IRequestQuestionDetail[] => {
  return details.filter((detail) => isRequestDetailFilled(detail));
};

export const isAnswerRequestDetailType = (
  type: REQUEST_QUESTION_TYPES
): type is REQUEST_QUESTION_TYPES.SHORT_ANSWER | REQUEST_QUESTION_TYPES.LONG_ANSWER | REQUEST_QUESTION_TYPES.DATE_AND_TIME => {
  switch (type) {
    case REQUEST_QUESTION_TYPES.SHORT_ANSWER:
    case REQUEST_QUESTION_TYPES.LONG_ANSWER:
    case REQUEST_QUESTION_TYPES.DATE_AND_TIME:
      return true;
    default:
      return false;
  }
};

export const isAnswerRequestDetail = (
  detail: IRequestQuestionDetail
): detail is IRequestQuestionAnswerDetail => {
  return isAnswerRequestDetailType(detail.type);
};

export const getRequestDetailAnswer = (detail: IRequestQuestionAnswerDetail): string => {
  switch (detail.type) {
    case REQUEST_QUESTION_TYPES.SHORT_ANSWER:
    case REQUEST_QUESTION_TYPES.LONG_ANSWER:
      return detail.answer || '';
    case REQUEST_QUESTION_TYPES.DATE_AND_TIME:
      return formatDateAndTimeDetail(detail);
    default:
      return '';
  }
};

export const formatDateAndTimeDetail = (detail: Pick<IDateAndTimeRequestQuestionDetail, 'date' | 'time'>): string => {
  const parts: string[] = [];

  if (detail.date) {
    const date = moment(detail.date);
    parts.push(date.isValid() ? date.format('DD MMM YYYY') : detail.date);
  }

  if (detail.time) {
    parts.push(detail.time);
  }

  return parts.join(', ');
};

function isRequestDetailFilled(detail: IRequestQuestionDetail): boolean {
  switch (detail.type) {
    case REQUEST_QUESTION_TYPES.SHORT_ANSWER:
    case REQUEST_QUESTION_TYPES.LONG_ANSWER:
      return Boolean(detail.answer);
    case REQUEST_QUESTION_TYPES.DATE_AND_TIME:
      return Boolean(detail.date || detail.time);
    case REQUEST_QUESTION_TYPES.UPLOAD_IMAGE:
      return Boolean(detail.images && detail.images.length > 0);
    case REQUEST_QUESTION_TYPES.MULTIPLE_CHOICE:
      return Boolean(detail.choices && detail.choices.length > 0);
    default:
      return false;
  }
}
